module.exports = __webpack_public_path__ + "img/tnc.614c86ad.svg";